module.exports = __webpack_public_path__ + "img/loader.a63bd6e0.gif";